import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { PhoneNumberAudit, PhoneNumberSkeleton } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-emergency-contact-phone-number-audit-list',
  templateUrl: './person-profile-emergency-contact-phone-number-audit-list.component.html',
  styleUrls: ['./person-profile-emergency-contact-phone-number-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileEmergencyContactPhoneNumberAuditListComponent implements OnInit {
  @Input() emergencyContactPhoneNumber: PhoneNumberSkeleton;
  @Input() loading: boolean;
  @Input() emergencyContactPhoneNumberAudits: PhoneNumberAudit[];

  @Output() loadEmergencyContactPhoneNumberAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadEmergencyContactPhoneNumberAudits.emit(this.emergencyContactPhoneNumber.phoneNumberId);
  }

  onNextPage() {
    this.nextPage.emit(this.emergencyContactPhoneNumber.phoneNumberId);
  }
}
